import { useParameter } from '../../../shared';

export function useDescription() {
  const description = [
    'Showing historical price development for crop commodities (weekly prices)',
    'Providing information on stock to use-ratio and months of supply for crops',
    'Stock-use-ratio - Percentage of domestic consumption which can be covered by stocks (Ending stocks / Domestic consumption (in %))',
    'Months of Supply - Number of months the domestic consumption can be covered by stocks (Ending stocks / Domestic consumption x 12)',
    'Source: ICE, NYSE, USDA , FAO International Commodity Prices, USDA PS&D (Field crops; stock-to-use ratio), USDA Projections, Global Insight (Sugar crops)'
  ];
  return description;
}